import react, { useEffect, useState, lazy } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  IconButton,
  Avatar,
  Divider,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  messageListAtom,
  // isMobileDeviceAtom,
  showMobileViewAtom,
  userDetailAtom,
  userInfoFormEnableDisableAtom,
  userJourneyAtom,
  userRawLeadFormDataAtom,
} from '../../Services/_states';
import { InterveneActions } from '../../Services/_actions/Intervene/intervene.actions';
import UserJourney from './UserJourney';
import UserInfo from './UserInfo/index.tsx';
import CustomerActivity from './customerActivity';
import EditSupplierModal from './EditSupplierModal.tsx';
import { ConstantActions, LeadFormActions } from '../../Services/_actions/index.js';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import { BorderBottom } from '@mui/icons-material';
import React from 'react';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { globalpermissions } from '../../Services/Permission.js';

const ChatTypes = [{ label: "All", value: "all" }, { label: "Bot", value: "bot" }, { label: "You", value: "human_agent" }];
const UserProfile = () => {
  const [userDetails, setUserDetails] = useRecoilState(userDetailAtom);
  const isMobile = !useMediaQuery('(max-width:1024px)');
  const [showMobileView, setShowMobileView] = useRecoilState(showMobileViewAtom);
  const [selectedOption, setSelectedOption] = useState([]);
  const [isEditUser, setIsEditUser] = useState(false);
  const [accordianKey, setAccordianKey] = useState('0');
  const actions = InterveneActions();
  const constantAction = ConstantActions();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const action = LeadFormActions();
  const [userRawLeadData, setUserRawLeadData] = useRecoilState(userRawLeadFormDataAtom);
  const [userInfoFormEnable, setUserInfoFormEnable] = useRecoilState(userInfoFormEnableDisableAtom);
  const userJourneyData = useRecoilValue(userJourneyAtom) || [];
  const [messageListState, setMessageListState] = useRecoilState(messageListAtom);
  const latestUsers = Object.values(
    userJourneyData?.reduce((acc, curr) => {
      const key = curr?.username;

      if (!acc[key]) {
        acc[key] = curr;
      }
      return acc;
    }, {})
  );

  const handleFilterChange = async (event) => {
    const selectedFilter = event.target.value;
    setMessageListState((prev) => ({ ...prev, messages: [], filters: { ...prev.filters, page: 1, chat_type: selectedFilter, intervened_by: "" } }));
    // setUserDetails((prev) => ({ ...prev, chat_type: selectedFilter }));
  };

  const getRawLeadForm = async () => {
    try {
      let response = await action.getDetailsByNumber(userDetails?.phone_number);
      if (response.status === 200 && response?.data?.data) {
        setUserRawLeadData({ ...response?.data });
        return response;
      } else {
        response = await action.getRawLeadForm();
        if (response.status === 200 && response?.data?.data) {
          setUserRawLeadData({ ...response?.data });
          return response;
        } else {
          if (response.status !== 200) {
            showSnackBar(`Error: ${response.status} - ${response.statusText}`, 'error');
          } else if (!response?.data?.data) {
            showSnackBar('No data available from the second API call.', 'error');
          } else {
            showSnackBar('An error occurred while fetching the form.', 'error');
          }
        }
      }
    } catch (error) {
      showSnackBar(error?.toString() || 'An unexpected error occurred', 'error');
    }
  };

  useEffect(() => {
    actions.getUserJourney(userDetails);
  }, []);

  const handleOpenModal = async () => {
    try {
      const response = await getRawLeadForm();
      if (response && response.status === 200) {
        setUserInfoFormEnable(false);
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error fetching lead form data:', error);
    }
  };
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ border: '1px solid #C9D2FF', backgroundColor: '#F2F4FF', borderRadius: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton
              onClick={() => {
                !isMobile
                  ? setShowMobileView({ userList: false, messageBox: true, userProfile: false })
                  : setShowMobileView({ userList: true, messageBox: true, userProfile: false });
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <Avatar
                alt={(userDetails?.whatsapp_name || userDetails?.phone_number)
                  ?.toString()
                  ?.trim()
                  ?.charAt(0)
                  ?.toUpperCase()}
                src={Avatar}
                sx={{ width: 80, height: 80 }}
              />
              <Box>
                <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 500, color: '#000' }}>
                  {userDetails?.whatsapp_name || userDetails?.phone_number}
                </Typography>
                <Typography sx={{ textAlign: 'center', color: '#404040' }}>
                  {userDetails?.phone_number}
                </Typography>
              </Box>
            </Box>
            {/* <IconButton
              onClick={() => navigate(`/r/edit-supplier/${userDetails?.phone_number}`)}
              sx={{ ml: 'auto' }}
            >
              <EditIcon fontSize="small" />
            </IconButton> */}
            <IconButton onClick={handleOpenModal} sx={{ ml: 'auto' }}>
              <EditIcon fontSize="small" sx={{ color: '#1631B1' }} />
            </IconButton>
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ px: { xs: '8px' }, pb: 2, overflow: 'auto', height: { xs: '67vh', sm: '40vh', md: '60vh', lg: '49vh', xl: '61vh' }, }}>
          <Accordion
            sx={{ border: '1px solid #C9D2FF', borderRadius: '4px' }}
            expanded={accordianKey === '0'}
            onChange={() => setAccordianKey((prev) => (prev === '0' ? null : '0'))}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                '& .MuiAccordionSummary-content': {
                  alignItems: 'center',
                },
                backgroundColor: '#F5F5F5',
              }}
            >
              <AccountCircleIcon sx={{ color: '#1631B1', mr: '5px', fontSize: '20px' }} />
              <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>User Info</Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                overflow: 'auto',
                backgroundColor: '#F5F5F5',
                height: { xs: 'auto', sm: 'auto', md: '120px', overflowY: 'auto' },
              }}
            >
              <UserInfo />
            </AccordionDetails>
          </Accordion>
          {/* {constantAction?.userHasPermission([globalpermissions?.interveneChat?.interveneChat]) && (
            <Box sx={{ px: 2, py: 1.5, border: '1px solid #C9D2FF', borderRadius: '4px', mt: 1, backgroundColor: '#F5F5F5' }}>
              <FormControl component="fieldset" sx={{ width: '100%' }}>
                <RadioGroup
                  row
                  value={messageListState?.filters?.chat_type ?? "human_agent"}
                  onChange={handleFilterChange}
                  sx={{ display: 'flex', justifyContent: 'space-around' }}
                >
                  {ChatTypes?.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item?.value}
                        control={<Radio size="small" sx={{ color: '#000', '&.Mui-checked': { color: '#1631B1' } }} />}
                        label={<Typography sx={{ fontSize: '14px' }}>{item?.label}</Typography>}
                      />
                    )
                  })}
                </RadioGroup>
              </FormControl>

              <Box sx={{ mt: 2 }}>
                <SearchableDropdown
                  options={latestUsers}
                  labelKey="username"
                  valueKey="username"
                  label="Select User"
                  value={latestUsers?.find((item) => item?.username === messageListState?.filters?.intervened_by) ?? null}
                  onChange={(value) =>
                    setMessageListState((prev) => ({
                      ...prev,
                      filters: {
                        ...prev.filters,
                        chat_type: "",
                        intervened_by: value?.username ?? "",
                      },
                    }))
                  }
                  size="small"
                  sx={{ width: '100%' }}
                />
              </Box>
            </Box>
          )} */}
          <Accordion
            sx={{ border: '1px solid #C9D2FF' }}
            expanded={accordianKey === '1'}
            onChange={() => setAccordianKey((prev) => (prev === '1' ? null : '1'))}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                '& .MuiAccordionSummary-content': {
                  alignItems: 'center',
                },
                backgroundColor: '#F5F5F5',
              }}
            >
              <ModeOfTravelIcon sx={{ color: '#1631B1', mr: '5px', fontSize: '20px' }} />
              <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>Customer Journey</Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                overflow: 'auto',
                backgroundColor: '#F5F5F5',
                height: { xs: 'auto', sm: 'auto', md: 'auto' },
                overflowY: 'auto',
              }}
            >
              {accordianKey === '1' && <UserJourney />}
            </AccordionDetails>
          </Accordion>
          {/* <Accordion
            expanded={accordianKey === '2'}
            onChange={() =>
              setAccordianKey((prev) => (prev === '2' ? null : '2'))
            }
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Customer Activity</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {accordianKey === '2' && <CustomerActivity />}
            </AccordionDetails>
          </Accordion> */}
        </Box>
      </Box>
      <EditSupplierModal
        props={{
          open: showModal,
          onClose: handleCloseModal,
          title: 'Supplier',
        }}
      />
    </>
  );
};

export default UserProfile;
